const install = function (Vue) {

    let filters = {
        date: function (value, format) {
            if (value) {
                let d = new Date(value);
                let yyyy = d.getFullYear();
                let mm = window.padLeft(d.getMonth() + 1, 2);
                let dd = window.padLeft(d.getDate(), 2);
                let hh = window.padLeft(d.getHours(), 2);
                let MM = window.padLeft(d.getMinutes(), 2);
                return format.replace('yyyy', yyyy).replace('mm', mm).replace('dd', dd).replace('hh', hh).replace('MM', MM);
            } else {
                return value;
            }
        },
        sex: function (value) {
            switch (value) {
                case "M": return "男";
                case "F": return "女";
                default: return value;
            }
        },
        semester: function (value) {
            switch (value) {
                case "u": return "上";
                case "d": return "下";
                default: return value;
            }
        }
    };

    Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));
}

export default { install };